import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import styles from './Styles';

class ErrorMessageBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
         
        };  
    }


    render() {
      
        const { text, error } = this.props;
        const snapErrorText='Oh snap! You got an error from backend! Please retry after sometime'
        return text ? (
            <div style={styles.relative}>
                <div style={error ? styles.mainError : styles.main}>
                    <div className="container messageBarDiv" style={styles.container}>
                        <Row>
                            <Col md={11} lg={11} xl={11}>
                                <Row>
                                    <p style={styles.message}>{text.message || snapErrorText}</p>
                                </Row>
                                {text.info ? <Row>
                                    <p style={styles.info}>{text.info}</p>
                                </Row> : null}
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

ErrorMessageBar.propTypes = {
    text: PropTypes.shape({
        message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        info: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    }),
    error: PropTypes.bool,
   // onClose: PropTypes.func,
};

ErrorMessageBar.defaultProps = {
    text: {
        message: null,
        info: null
    },
    error: false,
};

export default ErrorMessageBar;
